import styled from "@emotion/styled";

export const Button = styled.button`
  position: relative;
  width: 24px;
  height: 24px;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
`;
